// extracted by mini-css-extract-plugin
export default {"Banner":"Qq6M_r2UIgWaGm3PPz5p","defaultBackground":"fH58pdufk1dpzP33IuZC","bannerImage":"Sxcuak3jrq9rUsUgiPbA","logoImg":"Ef9jQFV9TAL4MPrkWKNE"};